import { Routes } from "@angular/router";

import { CheckoutConfirmationComponent } from "./components/checkout-confirmation/checkout-confirmation.component";
import { CheckoutPaymentComponent } from "./components/checkout-payment/checkout-payment.component";
import { CheckoutProcessComponent } from "./components/checkout-process/checkout-process.component";
import { CheckoutResolver } from "./providers/checkout-resolver";
import { CheckoutGuard } from "./providers/checkout.guard";

export const CHECKOUT_ROUTES = {
    SHIPPING: "shipping",
    PAYMENT: "payment",
    CONFIRMATION: "confirmation",
    CHECKOUT: "checkout",
    TERMS: "terms",
    CART: "cart",
} as const;


export const routes: Routes = [
    {
        path: "",
        component: CheckoutProcessComponent,
        resolve: {
            activeOrder: CheckoutResolver,
        },
        children: [
            {
                path: "",
                pathMatch: "full",
                redirectTo: CHECKOUT_ROUTES.PAYMENT,
            },
            {
                path: CHECKOUT_ROUTES.SHIPPING,
                redirectTo: CHECKOUT_ROUTES.PAYMENT,
            },
            {
                path: CHECKOUT_ROUTES.PAYMENT,
                component: CheckoutPaymentComponent,
                canActivate: [CheckoutGuard],
            },
            {
                path: `${CHECKOUT_ROUTES.CONFIRMATION}/:code`,
                component: CheckoutConfirmationComponent,
                canActivate: [CheckoutGuard],
            },
        ],
    },
];
